/* MAZI - fetch-inzending voor alle capturevlakken.
   Terugval: zonder JS post het formulier gewoon (challenge-pagina werkt dan).
   Detecteert Shopify's captcha-challenge en laat het formulier in dat
   geval alsnog native posten. Succes zet mazi:ingeschreven, wat de
   exit-popup permanent onderdrukt.

   De snippet emit zijn eigen <script>-tag per render; op een pagina met
   meerdere vlakken (PDP kan er drie dragen) voert de browser dit klassieke
   script dus meerdere keren uit. De vlag hieronder laat alleen de eerste
   uitvoering iets doen; per-element wordt er bovendien nog eens apart
   bewaakt zodat een latere, losstaande init-route nooit dubbel bindt. */
(function () {
  "use strict";
  if (window.__maziCaptureGeladen) return;
  window.__maziCaptureGeladen = true;
  function markeerIngeschreven() {
    try { localStorage.setItem("mazi:ingeschreven", "1"); } catch (e) {}
  }
  function bind(wrap) {
    if (wrap.dataset.gebonden === "1") return;
    wrap.dataset.gebonden = "1";
    var form = wrap.querySelector("form");
    var status = wrap.querySelector("[data-vorm-status]");
    if (!form || !status) return;
    form.addEventListener("submit", function (e) {
      if (form.dataset.zelf === "1") return; /* tweede poging: native */
      e.preventDefault();
      var knop = form.querySelector('button[type="submit"]');
      if (knop) knop.disabled = true;
      fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "text/html" },
      })
        .then(function (resp) {
          if ((resp.url && resp.url.indexOf("challenge") !== -1) || !resp.ok) {
            /* challenge-pagina, of elke niet-ok respons (bv. een kale 400
               bij een spam-geflagde sessie): hCaptcha haakt alleen echte
               formulierposts, niet fetch, dus alleen een echte native
               retry laat Shopify's captcha-flow alsnog aanslaan */
            form.dataset.zelf = "1";
            form.submit();
            return;
          }
          if (resp.ok && resp.url && resp.url.indexOf("customer_posted=true") !== -1) {
            /* Shopify's echte succes-signaal: redirect met customer_posted=true */
            status.textContent = wrap.dataset.succes;
            status.hidden = false;
            form.querySelector('input[type="email"]').value = "";
            markeerIngeschreven();
            document.dispatchEvent(new CustomEvent("mazi:ingeschreven"));
            return;
          }
          /* ok, maar geen succes-marker: geen echte fout, geen native
             terugval nodig, localStorage en event blijven ongemoeid */
          status.textContent = wrap.dataset.fout;
          status.hidden = false;
        })
        .catch(function () {
          status.textContent = wrap.dataset.fout;
          status.hidden = false;
        })
        .finally(function () {
          if (knop) knop.disabled = false;
        });
    });
  }
  function init() {
    document.querySelectorAll("[data-mazi-vorm]").forEach(bind);
    /* Vanuit e-mail: ?notify=1 (of #notify) opent de notify-uitklap,
       scrolt ernaartoe en zet de cursor in het veld. De herstelmails
       voor pre-orderverlaters linken hierheen. */
    if (/[?&]notify=1/.test(location.search) || location.hash === "#notify") {
      var uitklap = document.querySelector(".pdp-buy__notify");
      if (uitklap) {
        uitklap.open = true;
        uitklap.scrollIntoView({ block: "center" });
        var veld = uitklap.querySelector('input[type="email"]');
        if (veld) veld.focus({ preventScroll: true });
      }
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();

/* Exit-intent, een keer per bezoeker, nooit na een inschrijving.

   Desktop (fijne aanwijzer): popup, pas na 10s gewapend, zodra de muis
   boven uit het venster gaat.

   Telefoon (grove aanwijzer): een zwevende kaart onderaan in plaats van
   een popup. Die dekt de pagina niet af en de pagina blijft scrollbaar,
   want Google straft schermvullende popups op mobiel af en TV-kijkers
   komen via Google binnen. Gewapend na 12s en een derde van de pagina; de
   kaart verschijnt bij de eerste snelle scroll omhoog. Wie dan veegt is
   vaak nog aan het kijken, dus de kaart draagt de kop van de inschrijfband
   in plaats van "Voor je gaat". Nooit op productpagina's (data-exit-mobiel,
   daar gaat de koopknop voor), en nooit terwijl een inschrijfformulier, een
   lade, de cookiebalk, de landenbalk of een scrubfilm in beeld is; dan
   wacht hij op de volgende veeg. Een nieuwe bezoeker ziet dus eerst de
   cookiebalk weg voor de kaart kan komen. Inschrijvingen via de kaart dragen
   src-exit-mobile.

   Eigen bewaakvlag: dit bestand wordt via meerdere klassieke
   <script>-tags op eenzelfde pagina geladen (elke render van
   mazi-inschrijf-vorm of mazi-exit-popup emit er een), dus voert de
   browser het geheel opnieuw uit per tag. De eerste IIFE hierboven keert
   dan meteen terug dankzij haar eigen vlag; deze tweede IIFE heeft
   daarom een eigen vlag nodig om ook zichzelf maar een keer te laten
   draaien. */
(function () {
  "use strict";
  if (window.__maziExitGeladen) return;
  window.__maziExitGeladen = true;

  var BLAD_WACHT_MS = 12000;
  var BLAD_GELEZEN = 0.33;
  var VEEG_PX = 160;
  var VEEG_MS = 600;

  function markeerGetoond() {
    try { localStorage.setItem("mazi:exit-getoond", "1"); } catch (e) {}
  }

  function desktop(wortel) {
    var gewapend = false;
    setTimeout(function () { gewapend = true; }, 10000);
    function opWeg(e) {
      if (!gewapend || e.clientY > 0) return;
      wortel.hidden = false;
      markeerGetoond();
      document.removeEventListener("mouseleave", opWeg);
    }
    document.addEventListener("mouseleave", opWeg);
  }

  function inBeeld(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
  }

  /* Iets anders vraagt nu de aandacht, onderaan of over de pagina. */
  function bezet() {
    if (document.querySelector(".cart-drawer, .search-drawer, .mazi-geo, [data-drawer][data-open='true'], #shopify-pc__prefs[style*='display: block']")) return true;
    /* De hoogte van het paneel zelf, niet de wortel: die wortel houdt een
       lege box terwijl alleen zijn vaste paneel zichtbaar is of niet. */
    var cookiebalk = document.querySelector("#shopify-pc__banner .shopify-pc__banner__wrapper");
    if (cookiebalk && cookiebalk.getBoundingClientRect().height > 0) return true;
    var actief = document.activeElement;
    if (actief && /^(INPUT|TEXTAREA|SELECT)$/.test(actief.tagName)) return true;
    /* Een scrubfilm vraagt veegbewegingen; een formulier in beeld vraagt
       het al zelf. */
    var inBeeldNu = document.querySelectorAll("[data-mazi-film], [data-scrub-video], .mazi-inschrijven, .mazi-footer__form");
    for (var i = 0; i < inBeeldNu.length; i++) if (inBeeld(inBeeldNu[i])) return true;
    return false;
  }

  function telefoon(wortel, sluit) {
    var begin = Date.now();
    var diepste = window.scrollY;
    var vorige = window.scrollY;
    var veegStart = null;
    var veegVan = 0;

    function toon() {
      window.removeEventListener("scroll", opScroll);
      wortel.classList.add("mazi-exit--blad");
      var kop = wortel.querySelector(".mazi-exit__kop");
      if (kop && kop.dataset.kopBlad) kop.textContent = kop.dataset.kopBlad;
      var paneel = wortel.querySelector(".mazi-exit__paneel");
      if (paneel) paneel.setAttribute("aria-modal", "false");
      var tags = wortel.querySelector('input[name="contact[tags]"]');
      if (tags) tags.value = tags.value.replace("src-exit", "src-exit-mobile");
      wortel.hidden = false;
      markeerGetoond();
    }

    function opScroll() {
      var y = window.scrollY;
      var nu = Date.now();
      if (y > diepste) diepste = y;
      if (y < vorige) {
        if (veegStart === null || nu - veegStart > VEEG_MS) { veegStart = nu; veegVan = vorige; }
        var ruimte = document.documentElement.scrollHeight - window.innerHeight;
        var gelezen = ruimte > 0 ? diepste / ruimte : 1;
        if (veegVan - y >= VEEG_PX && nu - begin >= BLAD_WACHT_MS && gelezen >= BLAD_GELEZEN && !bezet()) toon();
      } else {
        veegStart = null;
      }
      vorige = y;
    }

    window.addEventListener("scroll", opScroll, { passive: true });
    /* Wie daarna een lade opent of iets in de mand legt, is aan het kopen. */
    document.addEventListener("click", function (e) {
      if (!wortel.hidden && e.target.closest && e.target.closest("[data-cart-open], [data-search-open], [data-drawer-open]")) sluit();
    });
    document.addEventListener("cart:updated", function () { if (!wortel.hidden) sluit(); });
  }

  function init() {
    var wortel = document.querySelector("[data-mazi-exit]");
    if (!wortel) return;
    var kan;
    try {
      kan = !localStorage.getItem("mazi:exit-getoond") &&
            !localStorage.getItem("mazi:ingeschreven");
    } catch (e) { return; }
    if (!kan) return;

    function sluit() { wortel.hidden = true; }
    wortel.addEventListener("click", function (e) {
      if (e.target === wortel || e.target.closest("[data-exit-sluit]")) sluit();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !wortel.hidden) sluit();
    });
    document.addEventListener("mazi:ingeschreven", function () { setTimeout(sluit, 2500); });

    if (window.matchMedia("(pointer: fine)").matches) {
      desktop(wortel);
    } else if (wortel.dataset.exitMobiel === "1") {
      telefoon(wortel, sluit);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
